import React from "react";
import { LogOut, ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";
import FeePaymentsView from "@/components/FeePaymentsView";

export default function AccountantDashboard() {
  const { logout } = useApp();
  return (
    <div className="min-h-screen bg-[#f6f2e6]" data-testid="accountant-dashboard">
      <header className="flex items-center justify-between bg-[#1b5e3f] px-6 py-4 text-white">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-6 w-6 text-[#E0A106]" />
          <div>
            <p className="text-[15px] font-bold leading-tight">पेमेंट / UTR रजिस्टर</p>
            <p className="text-[12px] text-emerald-100">लेखापाल (Accountant) — पेमेंट पडताळणी</p>
          </div>
        </div>
        <button onClick={logout} data-testid="accountant-logout" className="flex items-center gap-1.5 rounded-full bg-white/15 px-4 py-2 text-[13px] font-semibold hover:bg-white/25">
          <LogOut className="h-4 w-4" /> Logout
        </button>
      </header>

      <div className="mx-auto max-w-[1300px] p-5">
        <FeePaymentsView mode="accountant" />
      </div>
    </div>
  );
}
